import { action, thunk } from 'easy-peasy'
import ArrayofObjectToCamelCase from 'lib/transform/array-to-camel-case'
import IPavilionBrandCategoriesModel from 'services/Home/stores/models/PavilionBrandCategoriesModel/interface'

const PavilionBrandCategoriesModel: IPavilionBrandCategoriesModel = {
  isLoading: true,
  isError: false,
  errorMessage: '',
  categories: [],
  setCategories: action((state, payload) => {
    state.categories = payload
    state.isLoading = false
    state.isError = false
  }),
  getCategories: thunk(async (actions, payload, { injections }) => {
    try {
      const { apiClient } = injections
      const { data } = await apiClient({
        url: '/marketplace/v1/pavilion-brand/category-items',
        method: 'GET',
        params: {
          source_id: payload.sourceId,
          limit: payload.limit || 3,
        },
      })

      const items = data?.data?.items || []
      actions.setCategories(ArrayofObjectToCamelCase(items))
    } catch (err) {
      actions.error(
        err?.response?.data ||
          err?.message ||
          'Failed to fetch categories',
      )
    }
  }),
  error: action((state, payload) => {
    state.isLoading = false
    state.isError = true
    state.errorMessage = payload
  }),
}

export default PavilionBrandCategoriesModel
